import { React, useEffect, useRef } from "react";
import store from "../../../store";
import { Link } from "react-router-dom";
import useState from 'react-usestateref';
import classes from './Assessment.module.scss';
import ImpactLayer from "./ImpactLayer";
import PhaseNav from "./PhaseNav";
import VideoModal from "./VideoModal";

//MUI Imports
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

function Assessment({onUpdate, project, schema}) {

  const [assessmentData, setAssessmentData] = useState(null);
  const [assessmentMitigationChoices, setAssessmentMitigationChoices] = useState(null);
  const [assessmentPhaseIndex, setAssessmentPhaseIndex] = useState(0);
  const [shouldRender, setShouldRender] = useState(false);
  const [assessmentPhaseKey, setAssessmentPhaseKey] = useState("");

  let firstChosenLayerIndex = useRef(null);

  function onChange(forPhaseKey, forLayerKey, forQuestionIndex, value, forAnswerKey){

    let assessmentDataClone = JSON.parse(JSON.stringify(assessmentData))
    
    if(assessmentDataClone === null){
      assessmentDataClone = {}
    }

    if(assessmentDataClone.phases === null || assessmentDataClone.phases === undefined){
      assessmentDataClone.phases = {}
    }

    if(assessmentDataClone.phases[forPhaseKey] === undefined || assessmentDataClone.phases[forPhaseKey] === null){
      //If this is the first time assigning a value,  we need to create the objects before storing the data
      assessmentDataClone.phases[forPhaseKey] = {}
    }

    if(assessmentDataClone.phases[forPhaseKey][forLayerKey] === undefined || assessmentDataClone.phases[forPhaseKey][forLayerKey] === null){
      assessmentDataClone.phases[forPhaseKey][forLayerKey] = {}
    }

    if(assessmentDataClone.phases[forPhaseKey][forLayerKey].questions === undefined || assessmentDataClone.phases[forPhaseKey][forLayerKey].questions === null){
      assessmentDataClone.phases[forPhaseKey][forLayerKey].questions = []
    }

    if(assessmentDataClone.phases[forPhaseKey][forLayerKey].questions[forQuestionIndex] === undefined || assessmentDataClone.phases[forPhaseKey][forLayerKey].questions[forQuestionIndex] === null){
      assessmentDataClone.phases[forPhaseKey][forLayerKey].questions[forQuestionIndex] = {}
    }
    
    assessmentDataClone.phases[forPhaseKey][forLayerKey].questions[forQuestionIndex][forAnswerKey] = value

    onUpdate("assessment", assessmentDataClone);

  }

  function onPriorityChosen(questionIndex, choices, layerKey){

    let assessmentDataClone = JSON.parse(JSON.stringify(assessmentData))

    if(assessmentDataClone.priorityQuestions === null || assessmentDataClone.priorityQuestions === undefined){
      assessmentDataClone.priorityQuestions = {}
    }

    if(assessmentDataClone.priorityQuestions[layerKey] === null || assessmentDataClone.priorityQuestions[layerKey] === undefined){
      assessmentDataClone.priorityQuestions[layerKey] = []
    }

    assessmentDataClone.priorityQuestions[layerKey] = choices

    onUpdate("assessment", assessmentDataClone);

  }

  useEffect(() => {

    if(project){

      if(project.entries.screeningLayerOptions !== undefined){

        setAssessmentMitigationChoices(project.entries.screeningLayerOptions)
      }

      if(project.entries.assessment !== undefined){

        setAssessmentData(project.entries.assessment)

      }

    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[project])

  useEffect(() => {
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    
    setAssessmentPhaseKey(schema.screenContent.assessment.phases[assessmentPhaseIndex].key)
    setShouldRender(false);
    setTimeout(() => {
      setShouldRender(true);
    }, 400);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[assessmentPhaseIndex])

  return (
    <div>
      <div className={`${classes.AssesmentPage__header_container}`}>
        <VideoModal schema={schema}/>
        <div className="small_copy" dangerouslySetInnerHTML={{__html:schema.screenContent.assessment.heading.body}}></div>
      </div>
      <div className={`gain_content_container`}>
      <div className={`${classes.AssesmentPage__container}`}>
        <PhaseNav 
          phases={schema.screenContent.assessment.phases} 
          phaseIndex={assessmentPhaseIndex}
          onPhaseSelect={(index) => setAssessmentPhaseIndex(index)}/>
        {(
          assessmentMitigationChoices && schema && project
          ?
            <>
              {shouldRender
              ?
                <Box className={`${classes.AssesmentPage__wrapper}`}>
                  {
                    
                    schema.entryOptions.screen.screening.fields.map((screeningChoicesFields, layerIndex)=>{
                      
                      let layerChoiceTitle = screeningChoicesFields.label
                      let key = screeningChoicesFields.key
                      
                      //Ensure the type is a boolean
                      let chosen = typeof assessmentMitigationChoices[key] == "boolean" ? assessmentMitigationChoices[key] : (assessmentMitigationChoices[key] === 'true')
                      
                      if(firstChosenLayerIndex.current === null && chosen){
                        firstChosenLayerIndex.current = layerIndex
                      }
                      
                      return (
                        <ImpactLayer 
                          defaultOpen={(firstChosenLayerIndex.current === layerIndex ? true : false)}
                          key={layerIndex}
                          layerIntro={schema.screenContent.assessment.descriptions}
                          assessmentPhaseKey={assessmentPhaseKey}
                          layerQuestionValues={assessmentData}
                          layerKey={key}
                          definitions={schema.screenContent.definitions.forLayers}
                          fields={schema.entryOptions.screen.assessment.fields}
                          mitigationFields={schema.entryOptions.screen.assessment.mitigatingActions.fields}
                          mitigationBody={schema.entryOptions.screen.assessment.mitigatingActions.body}
                          riskOptions={schema.entryOptions.screen.assessment.riskOptions}
                          onPhaseUpdate={(questionIndex, answerValue, forAnswerKey) => onChange(assessmentPhaseKey, screeningChoicesFields.key, questionIndex, answerValue, forAnswerKey)}
                          layerChoiceTitle={layerChoiceTitle} 
                          chosen={chosen}
                          onPriorityChosen={onPriorityChosen}
                          impactLayer={schema.screenContent.assessment.impactLayers[key]}
                          favouriteContent={schema.screenContent.assessment.favourite} 
                          layerIndex={layerIndex}
                        />
                      )
                    })
                  }
                </Box>
                :
                <Box className={`${classes.AssesmentPage__wrapper}`}>
                <h2 className="holder_text content_wrapper__inner">Loading phase</h2>
                </Box>
              }
              
                  <Box className={`${classes.AssesmentPage__button_container} content_wrapper__inner`}>
                    <Link className={"inline_button inline_button__large"} to={`${process.env.PUBLIC_URL}/project/${project.projectId}/${store.getState().pages.screening.slug}`}>
                      <Button variant="contained">Back to screening</Button>
                    </Link>

                    <Link className={"inline_button inline_button__large"} to={`${process.env.PUBLIC_URL}/project/${project.projectId}/${store.getState().pages.results.slug}`}>
                      <Button variant="contained">Go to results</Button>
                    </Link>
                  </Box>
            
            </>
          :
          <>
            <h2 className="holder_text content_wrapper__inner">Choose which layers you'd like to screen in the "screening section"</h2>
          </>
          
        )}
      </div>
    </div>
    </div>
  );
}
export default Assessment